import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";
import {
    UpdateCommunicationConsentMutation,
    UpdateCommunicationConsentMutationVariables,
} from "./__generated__/useUpdateCommunicationConsent";

export const UPDATE_COMMUNICATION_CONSENT = gql`
    mutation UpdateCommunicationConsent(
        $userPublicId: String!
        $email: Boolean
        $paperMail: Boolean
        $textMessage: Boolean
        $paperlessEobs: Boolean
        $source: String
    ) {
        updateCommunicationConsent(
            userPublicId: $userPublicId
            email: $email
            paperMail: $paperMail
            textMessage: $textMessage
            paperlessEobs: $paperlessEobs
            source: $source
        ) {
            success
            errors
        }
    }
`;

type Props = {
    userPublicId: string;
    email?: boolean;
    paperMail?: boolean;
    textMessage?: boolean;
    paperlessEobs?: boolean;
    source?: string;
    onCompleted?: (data: UpdateCommunicationConsentMutation) => void;
};

export function useUpdateCommunicationConsent(props?: Props) {
    const onCompleted = props?.onCompleted;
    const variables = {
        userPublicId: props?.userPublicId || "",
        email: props?.email,
        paperMail: props?.paperMail,
        textMessage: props?.textMessage,
        source: props?.source,
    };
    return useMutation<
        UpdateCommunicationConsentMutation,
        UpdateCommunicationConsentMutationVariables
    >(UPDATE_COMMUNICATION_CONSENT, {
        variables,
        onCompleted,
    });
}
